import { HTTP_INTERCEPTORS, HttpClient, HttpInterceptor } from '@angular/common/http';
import { Inject, inject, Injectable, Injector } from '@angular/core';
import { pathJoin } from '@asamco/utils';
import { L10nProvider, L10nTranslationLoader } from 'angular-l10n';
import { EMPTY, firstValueFrom, from, Observable } from 'rxjs';
import { catchError, map, switchAll, switchMap, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { AppSettings } from '../configuration/appsettings';

@Injectable({
	providedIn: 'root',
})
export class CustomTranslationLoader implements L10nTranslationLoader {
	name: string;
	asset: any;
	options?: any;


	constructor(private app: AppSettings) {
	}

	get(language: string, provider: L10nProvider): Observable<{ [key: string]: any }> {
		return from(fetch(pathJoin([this.app.deployUrl, provider.asset, `${language}.json`]))).pipe(
			catchError(_ => {
				localStorage.removeItem('defaultLocale');

				// Show warning to the user
				Swal.fire({
					icon: 'info',
					text: 'unfortunately we were unable to load the preferred language file.',
				});

				const fallback = from(fetch(pathJoin([this.app.deployUrl, 'assets/i18n', `en-US.json`])));
				return fallback;

			}),
			switchMap(resp => {
				console.log(resp);
				return from(resp.json());
			})
		);
	}
}
